import { useFormikContext } from 'formik';
import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { QcsToggleButtonGroup } from '../basic/QcsToggleButtonGroup';
import { QcsToggleButton } from '../basic/QcsToggleButton';

interface ToggleOption {
  value: any;
  label: string;
}

interface Props {
  className?: string;
  name: string;
  label?: React.ReactNode;
  options: ToggleOption[];
  fullWidth?: boolean;
  disabled?: boolean;
}

export const QcsToggleButtonFields: FC<Props> = ({ className, name, label, options, fullWidth, disabled }) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const value = _.get(values, name);

  return (
    <Box sx={{ mb: 2 }}>
      {label && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          {label}
        </Typography>
      )}
      <QcsToggleButtonGroup
        disabled={disabled}
        className={className}
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) setFieldValue(name, newValue);
        }}
        fullWidth={fullWidth}
      >
        {options.map((option) => (
          <QcsToggleButton sx={{ padding: '0.5rem 0.9rem' }} key={String(option.value)} value={option.value}>
            {option.label}
          </QcsToggleButton>
        ))}
      </QcsToggleButtonGroup>
    </Box>
  );
};
